<template>
  <div class="questionnaire-data-container">
    <ListHeader class="questionnaire-data-header" :showVipMessage="false" :listTitle="listTitle"></ListHeader>
    <QuestionnaireList v-show="toWhere === 'list'" @updateComponent="updateComponent"></QuestionnaireList>
    <QuestionnaireDetail v-if="toWhere === 'detail'" :formId="formId" :sourceIden="sourceIden" @updateComponent="updateComponent"></QuestionnaireDetail>
  </div>
</template>

<script>
import ListHeader from '@components/list/listHeader'
import QuestionnaireList from './components/questionnaireList.vue'
import QuestionnaireDetail from './components/questionnaireDetail.vue'
export default {
  name: 'QuestionnaireData',
  data() {
    return {
      listTitle: '读者在线问卷数据',
      toWhere: 'list',
      formId: null,
      sourceIden: null
    }
  },
  computed: {
    currentComponent() {
      return this.$store.state.manage.componentManagerQuestionnaire
    }
  },
  methods: {
    updateComponent(params) {
      this.toWhere = params.toWhere
      if (params.toWhere === 'detail') {
        this.listTitle = typeof params.form.formName === 'undefined' ? '详细数据' : params.form.formName + '详细数据'
        this.formId = params.form.id
        this.sourceIden = params.form.sourceIden
      } else {
        this.listTitle = '读者在线问卷数据'
      }
    }
  },
  components: {
    ListHeader,
    QuestionnaireList,
    QuestionnaireDetail
  }
}
</script>
<style lang="scss" scoped>
.questionnaire-data-container {
  width: 100%;
  height: 100%;
  padding-left: 18px;
}
</style>
